"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLoggingEvent = exports.trackPageView = exports.trackVirtualPageView = exports.trackEventWithNoCategory = exports.trackEventBuyer = exports.trackEventBuyerWithExtraParams = exports.trackEventSeller = exports.trackEventSellerWithExtraParams = exports.trackEvent = exports.gtmScreenName = exports.dialogPageScreen = exports.masterPageScreen = void 0;
const screens_1 = __importDefault(require("./screens"));
const helpers_1 = require("../helpers");
const PAGE_VIEW_BLOCKING_TIMEOUT = 500;
const getDefaultGtmParams = () => {
    return window['gtmDefaultParams'] || {};
};
const getExtraGtmParamsWithDefault = () => {
    return Object.assign(Object.assign({}, getDefaultGtmParams()), (window['gtmExtraData'] || {}));
};
const trackEvent = (action, label, type = null, isDialogEvent = false, ignoreLabel = false, extraData = null) => {
    if (!(0, helpers_1.isBrowser)())
        return;
    window["dataLayer"] = window["dataLayer"] || [];
    const screenKey = isDialogEvent ? exports.dialogPageScreen : exports.masterPageScreen;
    const { screenName } = screens_1.default[screenKey] || {};
    if (ignoreLabel === false) {
        window["gtmLastAction"] = label;
    }
    window['dataLayer'].push(Object.assign(Object.assign({}, (extraData && typeof extraData === "object"
        ? Object.assign(Object.assign({}, getDefaultGtmParams()), extraData) : getExtraGtmParamsWithDefault())), { Screen: screenName, event: "UserInteraction", eventAction: action, eventCategory: type ? type : "empty", eventLabel: label }));
};
exports.trackEvent = trackEvent;
const trackEventSellerWithExtraParams = (
// events related to postView most of the time
action, label, extraData = {}) => {
    (0, exports.trackEventSeller)(action, label, false, false, extraData);
};
exports.trackEventSellerWithExtraParams = trackEventSellerWithExtraParams;
const trackEventSeller = (action, label, isDialogEvent = false, ignoreLabel = false, extraData = null) => {
    (0, exports.trackEvent)(action, label, "Sellers", isDialogEvent, ignoreLabel, extraData);
};
exports.trackEventSeller = trackEventSeller;
const trackEventBuyerWithExtraParams = (
// events related to postView most of the time
action, label, extraData = {}) => {
    (0, exports.trackEventBuyer)(action, label, false, false, extraData);
};
exports.trackEventBuyerWithExtraParams = trackEventBuyerWithExtraParams;
const trackEventBuyer = (action, label, isDialogEvent = false, // for SLR events most of the time
ignoreLabel = false, extraData = null) => {
    (0, exports.trackEvent)(action, label, "Buyers", isDialogEvent, ignoreLabel, extraData);
};
exports.trackEventBuyer = trackEventBuyer;
const trackEventWithNoCategory = (action, label, isDialogEvent = false, ignoreLabel = false) => {
    (0, exports.trackEvent)(action, label, "", isDialogEvent);
};
exports.trackEventWithNoCategory = trackEventWithNoCategory;
const trackVirtualPageView = (screenName) => {
    window['dataLayer'].push(Object.assign(Object.assign({}, getExtraGtmParamsWithDefault()), { Screen: screenName, event: "ScreenView", screenName: screenName }));
};
exports.trackVirtualPageView = trackVirtualPageView;
let isBlocked = {};
const trackPageView = (screenKey, isDialog = false, timeout = 0) => {
    var _a;
    if (!(0, helpers_1.isBrowser)())
        return;
    if (isBlocked === null || isBlocked === void 0 ? void 0 : isBlocked[screenKey])
        return;
    isBlocked[screenKey] = true;
    setTimeout(() => isBlocked[screenKey] = false, PAGE_VIEW_BLOCKING_TIMEOUT);
    window['trackEventSeller'] = exports.trackEventSeller;
    window['trackEventBuyer'] = exports.trackEventBuyer;
    window['trackEventBuyerWithExtraParams'] = exports.trackEventBuyerWithExtraParams;
    window['dataLayer'] = window['dataLayer'] || [];
    const { screenName } = screens_1.default[screenKey];
    if (isDialog) {
        exports.dialogPageScreen = screenKey;
    }
    else {
        exports.masterPageScreen = screenKey;
    }
    // = cookiesAndLocalStorage.get ?? '';
    window["gtmPrevScreen"] = (_a = localStorage.getItem("currentScreen")) !== null && _a !== void 0 ? _a : "";
    window.Screen = screenName;
    exports.gtmScreenName = screenName;
    localStorage.setItem("currentScreen", screenName);
    const cp = () => {
        window["dataLayer"].push(JSON.parse(JSON.stringify(Object.assign(Object.assign({}, getExtraGtmParamsWithDefault()), { Screen: screenName, event: "ScreenView", screenName: screenName }))));
    };
    if (timeout) {
        setTimeout(cp, timeout);
    }
    else {
        cp();
    }
};
exports.trackPageView = trackPageView;
const trackLoggingEvent = (body) => {
    window["dataLayer"] = window["dataLayer"] || [];
    window["dataLayer"].push(Object.assign({ event: "OSLogging" }, body));
};
exports.trackLoggingEvent = trackLoggingEvent;
